<aside class="w-full space-y-4">
  <!-- Card do perfil -->
  <div class="w-full max-w-[280px] sm:max-w-none rounded-xl shadow overflow-hidden mx-auto bg-white pb-4">

    <div class="w-full min-h-[250px] sm:min-h-[300px] rounded-t-xl bg-black shadow overflow-hidden mx-auto pb-6">
      <div class="flex flex-col items-center">
        <img [src]="userAvatar" [alt]="userName" class="w-full h-[180px] sm:h-[200px] object-cover" />

        <h4 class="font-semibold text-[22px] sm:text-[26px] text-white leading-tight mt-4 mb-2 px-2 text-center">
          {{ userName }}
        </h4>
        <p class="text-xs text-white text-center">
          Membro desde {{ userSince || '—' }}
        </p>

        <div *ngIf="companyName" class="mt-4 flex flex-col items-center px-4 w-full">
          <img *ngIf="companyLogo" [src]="companyLogo" alt="Logo da Empresa" class="w-12 h-12 rounded bg-white object-contain mb-1 shadow" />
          <p class="text-sm font-semibold text-white text-center leading-tight">
            {{ companyName }}
          </p>
        </div>
      </div>
    </div>

    <ng-container *ngIf="!profileCompleted">
      <!--<p class="text-md text-gray-600 font-semibold text-center p-4">Finalize seu perfil e ganhe 5% de desconto!</p>-->
      <p class="text-md text-gray-600 font-semibold text-center p-4">Seu perfil está incompleto, finalize-o e aproveite mais nossa rede!</p>
      <div class="w-full max-w-md p-2">
        <div class="mb-1 flex items-center justify-between">
          <span class="text-sm font-medium text-gray-700">Progresso</span>
        </div>
        <div class="relative w-full h-6 bg-gray-200 overflow-hidden">
          <div class="absolute left-0 top-0 h-full bg-black" [style.width.%]="profilePercent"></div>
          <div class="absolute inset-0 z-10 flex items-center justify-center pointer-events-none">
            <span class="text-xs font-bold text-red-500 drop-shadow">
              {{ profilePercent }}%
            </span>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="profileCompleted">
      <p class="text-md text-gray-700 font-semibold text-center p-4 leading-snug">
        Parabéns! Você completou seu perfil e agora pode aproveitar ao máximo o que nossa rede tem a oferecer.
      </p>
    </ng-container>

    <!-- Abaixo do progresso (ou da mensagem de perfil completo): totais; clique abre o perfil na seção Rede -->
    <a
      *ngIf="followingTotal != null || followersTotal != null"
      routerLink="/user-profile"
      fragment="rede"
      class="block mx-3 mb-3 px-3 py-2.5 rounded-lg border border-gray-100 bg-gray-50/90 text-center hover:bg-gray-100 transition focus:outline-none focus-visible:ring-2 focus-visible:ring-[#E90128] focus-visible:ring-offset-2"
    >
      <span class="text-sm font-semibold text-gray-900 leading-snug">
        {{ followingTotal != null ? followingTotal : '—' }} seguindo
        <span class="text-gray-400 font-normal mx-1" aria-hidden="true">·</span>
        {{ followersTotal != null ? followersTotal : '—' }} seguidores
      </span>
      <span class="block text-[10px] text-gray-500 mt-1">Ver no perfil</span>
    </a>
  </div>

  <!-- Ações -->
  <nav class="p-4 rounded-xl bg-white shadow">
    <div class="flex flex-col gap-3">
      <a class="btn-red" href="/user-profile">Meu perfil</a>
      <a *ngIf="!controlNavDisabled" class="btn-red" href="/control">Painel de controle</a>
      <span
        *ngIf="controlNavDisabled"
        class="btn-red btn-red--disabled"
        aria-disabled="true"
        aria-current="page"
        >Painel de controle</span
      >
      <a *ngIf="!membersNavDisabled" class="btn-red" href="/members">Membros</a>
      <span
        *ngIf="membersNavDisabled"
        class="btn-red btn-red--disabled"
        aria-disabled="true"
        aria-current="page"
        >Membros</span
      >
      <!--<a class="btn-red" href="#">Benefícios</a>-->
      <a class="btn-red cursor-pointer" (click)="logout($event)">Sair</a>
    </div>
  </nav>

  <!-- Ajuda -->
  <div class="p-4 rounded-xl bg-white shadow">
    <p class="text-lg text-gray-800 font-semibold">Precisa cancelar sua participação?</p>
    <p class="text-sm text-gray-600">
      Entre em contato conosco
      <a class="text-[#E90128] font-semibold hover:underline"
         href="https://wa.me/5582998098686"
         target="_blank"
         rel="noopener noreferrer">clicando aqui</a>.
    </p>
  </div>
</aside>
